import { render, staticRenderFns } from "./ExportConversationsModal.vue?vue&type=template&id=56b86964&scoped=true&"
import script from "./ExportConversationsModal.vue?vue&type=script&lang=js&"
export * from "./ExportConversationsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportConversationsModal.vue?vue&type=style&index=0&id=56b86964&lang=scss&scoped=true&"
import style1 from "./ExportConversationsModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b86964",
  null
  
)

export default component.exports